"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicForm = function (_Component) {
  _inherits(DynamicForm, _Component);

  function DynamicForm() {
    _classCallCheck(this, DynamicForm);

    return _possibleConstructorReturn(this, (DynamicForm.__proto__ || Object.getPrototypeOf(DynamicForm)).apply(this, arguments));
  }

  _createClass(DynamicForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoSubmit) {
        this._form.submit();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          url = _props.url,
          parameters = _props.parameters,
          otherProps = _objectWithoutProperties(_props, ["url", "parameters"]);

      return _react2.default.createElement(
        "form",
        _extends({
          ref: function ref(node) {
            return _this2._form = node;
          },
          method: "POST",
          action: url
        }, otherProps),
        Object.keys(parameters).map(function (key) {
          return _react2.default.createElement("input", { key: key, type: "hidden", name: key, value: parameters[key] });
        }),
        _react2.default.createElement("input", { type: "submit", value: "Click here if not redirected..." })
      );
    }
  }]);

  return DynamicForm;
}(_react.Component);

DynamicForm.defaultProps = {
  autoSubmit: true
};

exports.default = DynamicForm;